import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subelemento'
})
export class SubelementoPipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (value !== undefined) {
      const strValue = value + '';
      return strValue.replace(/(\d{2})(\d{3})/g, '\$1.\$2');
    } else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/subelemento.pipe.ts